import React, { Component } from 'react';
import { connect } from 'react-redux';
import { choseBankIndex,choseCurrentIndex ,choseBankOrCurrent} from '../../../action/productAction';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import NavigatorMain from '../../NavigatorMain';
import {bankCode} from '../../../BankCode';
import {
  getPayAll,
  goLogin
} from '../../../getPay';
class HqtCard extends Component {
  constructor(props) {
    super(props);
    this.state = {

  
    };
  }
  componentWillMount() {
    console.log("this.props.location.fetch")
  }
  choseBank(){
    hashHistory.push({
      pathname: '/HqtCardList',
      state:{
        type:this.props.type,
        actionType:this.props.actionType,
        // businessType:this.props.businessType,
        // text:this.props.text,
        // currentIndex:this.props.currentIndex,
        // currencyFundChange:this.props.currencyFundChange,
        // currentType:this.props.currentType,
        // payInfoData:this.props.payInfoData,
        callback:this.props.fetch
      }
    });
  }


  render(){
    const { 
      payInfoData,
      currentType,
      currentIndex,
    }=this.props;
    console.log(window.funSplit("500000.0"),"****")
    return (
      <div style={{marginBottom:10}}>
        {
          payInfoData.content.currentAccountList.length>0 && payInfoData.currentIndex != -1?payInfoData.content.currentAccountList.map( (item,i)=> {
            if (item.bankCode==this.props.hqtXz) {
              if (item.disable) {
                return(
                  <div key={`currentAccountList${i}`} onClick={()=>this.choseBank()} className='bankList' >
                    <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')}  className='img'/>
                    <div className='bankListTip'>
                      <p>{Util.formatStr(item.bankName)+'(*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}
                      { 
                        item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == null ?
                        item.enableCMBTrustChannel === "0" ?
                        <span style={{color:'rgb(104,113,126)',fontSize:12,padding:2,backgroundColor:"rgba(0,0,0,0.1)",justifyContent:"center",marginLeft:"5px"}}>不可用</span>
                        : 
                        null
                        :
                        null
                      }
                      </p>
                      {
                        item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == false ?
                        <p>招行卡暂不可用，请您去华夏基金管家App操作或咨询客服</p>
                        :
                        <p>{ window.funSplit(item.tradeMaxAmountTips)[1]} </p>
                      }
            
                    </div>
                    <div className='bankListRight'>
                    </div>
                  </div>
                )
              }else{
                return(
                  <div onClick={()=>this.choseBank()} style={{fontSize:15,height:'1.7rem',backgroundColor:'#fefefe',textAlign:'center',lineHeight:'1.7rem'}}>无支付方式</div>
                )
              }
            } 
          }):<div onClick={()=>this.choseBank()} style={{fontSize:15,height:'1.7rem',backgroundColor:'#fefefe',textAlign:'center',lineHeight:'1.7rem'}}>无支付方式</div>
        }
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  console.log(state,ownProps);
  return {
    payInfoData:state[ownProps.type+'PayInfo'],
    hqtXz:state.hqtXz
  }
}
export default connect(mapStateToProps)(HqtCard);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/HqtCard.js